module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "delete-count-down"
  }, [_c('h1', [_vm._v("PROCHAINES PÉRIODES PROMO")]), _vm._v(" "), _c('div', {
    staticClass: "countdown-list"
  }, [(_vm.getCountDownNext.length <= 0) ? _c('div', {
    staticClass: "listEmpty"
  }, [_vm._v(_vm._s(_vm.$t("countdown.emptycntd")))]) : _vm._e(), _vm._v(" "), (_vm.getCountDownNext.length > 0) ? _c('div', [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("countdown.colname")))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("countdown.colstartdate")))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("countdown.colenddate")))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("countdown.colstanddesign")))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("countdown.colbrand")))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("countdown.colcreateupdate")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getCountDownNext), function(countDown) {
    return _c('tr', [_c('td', {
      staticClass: "name"
    }, [_vm._v(_vm._s(countDown.name))]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.convertGmtToLocal(new Date(countDown.startDate)).toLocaleString()) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "utcForamt"
    }, [_vm._v("(" + _vm._s(countDown.startDate) + " UTC)")])]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.convertGmtToLocal(new Date(countDown.endDate)).toLocaleString()) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "utcForamt"
    }, [_vm._v("(" + _vm._s(countDown.endDate) + " UTC)")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(countDown.standDesign.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(countDown.standDesign.brand.name))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "dateAction"
    }, [_vm._v("Created : " + _vm._s(new Date(countDown.createdAt).toLocaleString()) + " "), _c('br'), _vm._v("\n                                by " + _vm._s(countDown.modifiedBy.firstname) + " " + _vm._s(countDown.modifiedBy.lastname))])])])
  }))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fe31ed4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/countdown/actions/ListNextCountDown.vue
// module id = 3071
// module chunks = 0